import {
  deletePushToken as _deletePushToken,
  FirestoreCollections,
} from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { removePushNotificationTokenDate } from 'shared/services/local-storage';

import {
  getUidByPushNotificationToken,
  removePushNotificationToken,
} from './helpers';

export const deletePushToken = async (token: string) => {
  const uid = getUidByPushNotificationToken(token);
  const logError = (error: unknown) =>
    logFirestoreWriteError({
      op: FirestoreWriteOp.DeletePushToken,
      error,
      docPath: `${FirestoreCollections.FcmTokens}/${token}`,
      uid: uid ?? undefined,
    });

  _deletePushToken({
    token,
    db: getFirestore(),
    doc,
    deleteDoc,
    onWriteError: logError,
  }).catch(logError);

  if (!uid) {
    return;
  }
  removePushNotificationToken(uid);
  removePushNotificationTokenDate(uid);
};
